import ElakayImage from '../../../components/images/ElakayImage';
import React from "react";
import { toImageUrl } from "../../../config";
import { useDropshippingText } from "../i18n";
import { elakayAutoText } from "../../pageInside/dataElakay";
import "./ProviderSectionHeader.css";
import { getNameInitials } from "../utils/providerShopIdentity";

// Provider Views/Likes + the Heart button (ticket §11/§13) are OPTIONAL props: passed by every
// caller that already has this Provider's real stats (e.g. ProviderMarketplaceBrowser.jsx, which
// gets them batched with zero extra requests -- see sellerProviderCatalogService.js), omitted by
// callers that don't (never a fabricated 0 shown as if it were real). isLiked reflects the
// authenticated Seller's own account, computed server-side -- never assumed from a local click alone
// until the request actually confirms it (onToggleLike is awaited by the caller, `liking` disables
// the button meanwhile).
const ProviderSectionHeader = ({ shopName, monogram, avatar, location, totalProducts, roleName, onViewProvider, providerViews, providerLikes, isLiked, onToggleLike, liking = false }) => {
  const translated = useDropshippingText();
  const fallback = {
    provider: "Provider", producer: "Producer", productCountOne: "{count} product", productCount: "{count} products", viewProviderShop: "View Provider Shop",
    providerViews: "{count} views", providerLikes: "{count} likes", likeProvider: "Like Provider", unlikeProvider: "Unlike Provider",
  };
  const t = (key, values) => {
    const label = translated(key, values);
    return label === key ? elakayAutoText(`h_spm_${key}`, fallback[key] || key, values) : label;
  };
  const name = typeof shopName === "string" ? shopName : "";
  const showStats = Number.isFinite(providerViews) || Number.isFinite(providerLikes);
  return (
    <div className="dsi-provider-header">
      <div className="dsi-provider-header__identity">
        {avatar ? <ElakayImage preset="avatar-tiny" className="dsi-provider-header__avatar" src={toImageUrl(avatar)} alt={name} loading="lazy" /> : (
          <div className="dsi-provider-header__avatar dsi-provider-header__avatar--placeholder" aria-hidden="true">{monogram || getNameInitials(name).slice(0, 3)}</div>
        )}
        <div>
          {name && <h2 className="dsi-provider-header__name">{name}</h2>}
          <span className="dsi-provider-header__badge">{t(roleName === "Producer" ? "producer" : "provider")}</span>
        </div>
      </div>
      <div className="dsi-provider-header__meta">
        {Number.isFinite(totalProducts) && <span>{t(totalProducts === 1 ? "productCountOne" : "productCount", { count: totalProducts })}</span>}
        {location && <span>{location}</span>}
        {showStats && <span>{t("providerViews", { count: providerViews || 0 })}</span>}
        {showStats && <span>{t("providerLikes", { count: providerLikes || 0 })}</span>}
      </div>
      {(onToggleLike || onViewProvider) && (
        <div className="dsi-provider-header__actions">
          {onToggleLike && (
            <button type="button" className={`dsi-provider-header__like-btn${isLiked ? " dsi-provider-header__like-btn--liked" : ""}`}
              disabled={liking} aria-pressed={Boolean(isLiked)} title={t(isLiked ? "unlikeProvider" : "likeProvider")}
              aria-label={t(isLiked ? "unlikeProvider" : "likeProvider")} onClick={onToggleLike}>
              {isLiked ? "♥" : "♡"}
            </button>
          )}
          {onViewProvider && <button type="button" className="dsi-provider-header__view-btn" onClick={onViewProvider}>{t("viewProviderShop")}</button>}
        </div>
      )}
    </div>
  );
};
export default ProviderSectionHeader;
